<template>
  <div
    ref="root"
    class="md:flex md:min-h-[480px]"
    :class="[{ 'md:items-stretch': stretch, 'md:items-center': !stretch }]"
  >
    <div class="mr-56 hidden grow md:relative md:block">
      <slot name="left" />
    </div>

    <div class="md:w-[400px] md:shrink-0">
      <slot name="right" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onUnmounted, ref } from 'vue'

import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { useIntersectionObserver } from '@vueuse/core'

const { trackProductBlockImpression } = useTracking()
const root = ref<HTMLElement | null>()

const THRESHOLDS: Record<string, number> = {
  default: 0.5,
  recap: 0.25,
}

const props = withDefaults(
  defineProps<{
    trackingId?: string
    trackingModel?: string
    stretch?: boolean
  }>(),
  {
    trackingId: '',
    trackingModel: '',
    stretch: false,
  },
)

function trackImpression() {
  trackProductBlockImpression({
    block_name: props.trackingId,
    product_model: props.trackingModel,
  })
}

const { stop } = useIntersectionObserver(
  root,
  ([{ isIntersecting }]) => {
    if (isIntersecting) {
      trackImpression()
    }
  },
  {
    threshold:
      props.trackingId in THRESHOLDS
        ? THRESHOLDS[props.trackingId]
        : THRESHOLDS.default,
  },
)

onUnmounted(() => {
  stop()
})
</script>
